import { Link } from "react-router";
import { _ } from "i18n";
import { Cell } from "./Cell";
import type { Keys } from "i18n/locales/types";
import Button from "ui-kit/src/ButtonComponent/Button";

interface BaseAction {
    label: string | keyof Keys;
    isTranslationKey?: boolean;
    disabled?: boolean;
    className?: string;
}

interface LinkAction extends BaseAction {
    type: 'link';
    to: string;
}

interface ButtonAction extends BaseAction {
    type: 'button';
    onClick: () => void;
}

type Action = LinkAction | ButtonAction;

interface ActionsCellProps {
    actions: Action[];
    className?: string;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({ actions = [], className = '' }) => {
    if (!actions || actions.length === 0) {
        return <Cell variant="action" />;
    }

    const renderAction = (action: Action, index: number) => {
        const baseClassName = `actionsButton ${action.disabled ? 'disabled' : ''} ${action.className || ''} ${className}`;
        const label = action.isTranslationKey 
            ? _(action.label as keyof Keys).toUpperCase()
            : (action.label as string).toUpperCase();

        if (action.type === 'link') {
            return (
                <Link
                    key={index}
                    className={baseClassName}
                    to={action.to}
                >
                    {label}
                </Link>
            );
        }

        return (
            <Button
                key={index}
                className={baseClassName}
                variant={action.className === 'primary' ? 'primary' : 'secondary'}
                onPress={action.onClick}
                disabled={action.disabled}
            >
                {label}
            </Button>
        );
    };

    return (
        <Cell variant="action">
            {actions.map(renderAction)}
        </Cell>
    );
}; 